import services from './../../services/service'; // Service Class
import MainHeader from './../MainHeader/index.vue'; // Main Header
import MainFooter from './../MainFooter/index.vue'; // Main Footer
import Commons from '../../resources/commons.js'; //Commons class

let service = new services();

export default {
    name: 'Login',
    mixins: [Commons],
    data () {
        return {
            users: {},
            user: {},
            states: {},
            cities: {},
            disable_btn: false,
            data_error_message:"",
            disable_btn:false,
            action_loading:false,
            redir:"",
            redir_data:{}
        }
    },
    components: {
        'component-header': MainHeader,
        'component-footer': MainFooter
     },
    methods: {
        reset() {
            localStorage.removeItem("sp_user");
            localStorage.removeItem("sp_token");
            localStorage.removeItem("sp_token_key");
            localStorage.removeItem("sp_#_sellpoint");

            //clear local forage - users data
            localforage.removeItem(service.udb_name).then(function (value) {}).catch(function(err) {});

            //clear all forage //CHECK-LTR
            localforage.clear(); //clear all offline data

            //reset func
            //activate dynamic request
            // localforage.setItem(service.adr_db_name, self.redir_data).then(function (value) {
            // }).catch(function(err) {}); 
        },
        activate_processing(){
            this.disable_btn = true;
            this.action_loading = true;
        },

        deactivate_processing(){
            this.disable_btn = false;
            this.action_loading = false;
        },
        login(){
            this.activate_processing();
            this.data_error_message = "";
            var credentials = {
                user_email: this.user.email,
                user_password: this.user.password
            }

            let navi = this.$router;
            if(credentials.user_email != null && credentials.user_password != null) {
                service.loginUser(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        localStorage.setItem("sp_user", data.user_name); 
                        // localStorage.setItem("sp_token", data.user_session_key); //store session key here linked to session well @server
                        // localStorage.setItem("sp_token_key", data.user_token_key);
                        var user_data = {
                            "user_name": data.user_name,
                            "sp_token": data.user_session_key,
                            "sp_token_key": data.user_token_key,
                            "sps": data.user_sps,
                        }
                        var credentials = {
                            session_key: data.user_session_key
                        } 
                        //revalidate  here till next version update
                        service.sessionGuard(this, credentials).then(response => {
                            if(response.body.status == 200) {
                                let data = response.body.data;
                                data.forEach(function(element) {
                                    user_data.user_id = element.user_id;
                                }, this);

                                let self = this;
                                localforage.setItem(service.udb_name, user_data).then(function (value) {
                                    //move here
                                    //navi.push('/');
                                    //navi.push(self.redir);
                                    if(user_data.sps && (user_data.sps > 0)){
                                        navi.push('/dashboard');
                                    }else{
                                        navi.push(self.redir);
                                    }
                                    //call-set-push-notifications
                                    self.setPushNotification();
                                    //..//call-set-push-notifications
                                }).catch(function(err) {});
                            }else {
                                //this.$router.push('login');
                            }
                            this.loading = false;
                        }).catch((err) => {
                            if(err) {
                            //this.$router.push('login');
                            //console.log(err)
                            }
                        })
                        
                        // navi.push('/timeline');
                    }else{
                        // toastr.warning("invalid login credentials", 'Warning!'); 
                        this.data_error_message = "invalid login credentials";
                        // this.disable_btn = false;
                        this.deactivate_processing();
                    }
                }).catch((err) => {
                  //  console.log(err)
                    // toastr.warning("invalid login credentials", 'Warning!'); 
                    this.data_error_message = "Sorry, could not process request";
                    // this.disable_btn = false;
                    this.deactivate_processing();
                })
                    
            }else {
                // toastr.error('Kindly fill all fields', 'Warning!');
                this.data_error_message = "Kindly fill all fields";
                this.disable_btn = false;
            }
        },

        //to handle incoming request flowa
        doDynamicRedirectsDirects(){
            let self = this;
            //check if dynamic_requst is active
            localforage.getItem(service.adr_db_name, function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.redir = value.link;
                    self.redir_data = value;
                }else {
                    //else no requests direct to default page
                    self.redir = "/";
                }
                self.reset(); //reset here
            });
        },
    },
    created: function(){
        this.doDynamicRedirectsDirects();
       ///this.reset();
    }
}


// WEBPACK FOOTER //
// ./src/pages/Login/script.js